module.exports = __webpack_public_path__ + "img/qualifications2.3478ccb6.png";